module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/pickem-51218f6bbfc55ddd6bc0a6abd8d391f8.svg";